const axios = require('axios');
let serverAddress = null;
let token = null;

function redirectURL() {
    window.location.href = `${this.window.location.protocol}//${this.window.location.hostname}:${this.window.location.port}`
}

// Local Functions
setServerAddress();
function setServerAddress() {
    serverAddress = `${this.window.location.protocol}//${this.window.location.hostname}`//"https://salom.tasklogix.co.za"//
}

// Public Functions
function newReq(method, url, data = null, includeCredentials = true, fullResponse = false) {
    return new Promise((resolve, reject) => {
        let config = {method: method.toLowerCase(), url: `${serverAddress}/${url}`,}
        if (method.toLowerCase() !== 'get' && data !== null) {config.data = data}
        if (includeCredentials) {config.headers = {"tauth": token}}
        axios(config)
            .then(response => {
                if (response.status === 200) {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        resolve(fullResponse ? response: response.data)
                    }
                } else {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        reject(fullResponse ? response: response.data)
                    }
                }
            })
            .catch(e => {
                reject(e)
            })
    })
}

function newReqUpload(method, url, file = null, formFieldName = null, includeCredentials = true, onProgressCB = null, fullResponse = false) {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append(formFieldName, file);
        let config = {method: method.toLowerCase(), url: `${serverAddress}/${url}`, data: formData}
        if (onProgressCB != null)
            config.onUploadProgress = onProgressCB
        if (includeCredentials) {config.headers = {"tauth": token}}
        axios(config)
            .then(response => {
                if (response.status === 200) {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        resolve(fullResponse ? response: response.data)
                    }
                } else {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        reject(fullResponse ? response: response.data)
                    }
                }
            })
            .catch(e => {
                reject(e)
            })
    })
}

function newReqDownloadFile(method, url, data = null, filename = null, includeCredentials = true, fullResponse = false, overrideDefaultURL = false, urlResponse = false) {
    return new Promise((resolve, reject) => {
        let config = {method: method.toLowerCase(), url: overrideDefaultURL ? url : `${serverAddress}/${url}`, responseType: 'blob'}
        if (method.toLowerCase() !== 'get' && data !== null) {config.data = data}
        if (includeCredentials) {config.headers = {"tauth": token}}
        axios(config)
            .then(response => {
                if (response.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));

                    if (urlResponse) {
                        resolve(url)
                    } else {
                        const link = document.createElement('a');
                        link.href = url;
                        link.target = "_blank"
                        if (filename !== null)
                            link.setAttribute('download', filename); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        resolve(true)
                    }
                } else {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        reject(fullResponse ? response: response.data)
                    }
                }
            })
            .catch(e => {
                reject(e)
            })
    })
}



function initialize(tokenStr) {
    token = tokenStr;
}

function getToken() {
    return {token}
}

module.exports = {
    newReq,
    newReqUpload,
    newReqDownloadFile,
    initializeRequestAuth: initialize,
    redirectURL,
    token: getToken,
    getServerAddress: () => {
        return serverAddress
    }
}
